import uiLocale from '../../../utils/UILocale.js';

const translations = {
  moreDealSingle: uiLocale.getString('component.avm.moreDealSingle'),
  moreDealsMulti: uiLocale.getString('component.avm.moreDealsMulti'),
  endsToday: uiLocale.getString('component.avm.endsToday'),
  endsTomorrow: uiLocale.getString('component.avm.endsTomorrow'),
  endsSoon: uiLocale.getString('component.avm.endsSoon'),
  moreDetails: uiLocale.getString('component.avm.more_details'),
  dealsAvailable: uiLocale.getString('component.avm.dealsAvailable'),
  onedealAvailable: uiLocale.getString('component.avm.onedealAvailable')
};

export default translations;
